import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export default createReduxConstants('Modal', {
  CLOSE_OVERLAY: null,
  OPEN_OVERLAY: null
});
